export const getSiteUsersRoute = () => '/users';
export const getSiteUserEditRoute = (userId = null) => '/users/' + (userId ?? ':user');